import React, { createContext, useContext, useState, useCallback, useRef } from "react";

interface LoadingContextValue {
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
}

const LoadingContext = createContext<LoadingContextValue>({
  isLoading: false,
  setLoading: () => {},
});

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const counterRef = useRef(0);

  const setLoading = useCallback((loading: boolean) => {
    if (loading) {
      counterRef.current += 1;
    } else {
      counterRef.current = Math.max(0, counterRef.current - 1);
    }
    setIsLoading(counterRef.current > 0);
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
